export default "__VITE_ASSET__Ctoh4XEk__"